<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Audiências"
      Pagina="Jurídico"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 text-right" style="margin-bottom: 10px;">
                <button class="btn btn-primary" (click)="abrirModal()"><i class="fa fa-plus"></i> Novo</button>
              </div>
              <div class="col-md-12">
                <div class="card card-blue" style="margin-top:10px;padding-top: 7px">
                  <div class="card-header">
                    <h3 class="card-title">Audiências</h3>
                  </div>
                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Data / Hora</th>
                          <th>Processo</th>
                          <th>Local</th>
                          <th>Status</th>
                          <th style="width: 20px">*</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of itens | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                          <td>{{item.id}}</td>
                          <td>{{item.dataInicio | date: 'dd/MM/yyyy HH:mm'}}</td>
                          <td>{{item.processoTitulo}}</td>
                          <td>{{item.local}}</td>
                          <td>{{ getStatusDescricao(item.status) }}</td>
                          <td>
                            <button class="btn btn-warning" (click)="abrirModalDetalhes(item.id)"><i class="fa fa-edit"></i></button>
                          </td>
                        </tr>
                        <tr *ngIf="itens.length == 0">
                          <td colspan="6" class="text-center text-orange">Nenhum registro a ser mostrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer clearfix text-center" *ngIf="itens.length > 0">
                    <pagination-controls class="pagination-sm"
                                         [autoHide]="false"
                                         [directionLinks]="true"
                                         previousLabel="Anterior"
                                         nextLabel="Próximo"
                                         (pageChange)="paginaAtual = $event">
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  </section>
</div>
<app-novo-audiencia [isModal]="true" (atualizarLista)="buscarLista()"></app-novo-audiencia>
<app-detalhes (atualizarLista)="buscarLista()"></app-detalhes>
